module.exports = __webpack_public_path__ + "media/images/app/products/calendar-icon-55a4bd1c92bbd824f2bb185982c009ca.png";